import { render, staticRenderFns } from "./RsaSchedaEsameObiettivoGeneraleSistemaNervosoEditComponent.vue?vue&type=template&id=7d8ab4dd"
import script from "./RsaSchedaEsameObiettivoGeneraleSistemaNervosoEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaEsameObiettivoGeneraleSistemaNervosoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports